import { create } from "zustand";

export interface TablePaginationState {
  pageIndex: number;
  pageSize: number;
  setPageIndex: (index: number) => void;
  setPageSize: (size: number) => void;
  setPagination: (pagination: { pageIndex: number; pageSize: number }) => void;
}

export const useTableStore = create<TablePaginationState>((set) => ({
  pageIndex: 0,
  pageSize: 10,
  setPageIndex: (index) => set({ pageIndex: index }),
  setPageSize: (size) => set({ pageSize: size }),
  setPagination: ({ pageIndex, pageSize }) => set({ pageIndex, pageSize }),
}));
